import React, { memo, useContext, useState } from 'react';
import {
    Handle,
    NodeToolbar,
    Position,
    useConnection,
    useNodeConnections,
} from '@xyflow/react';
import { Checkbox, Divider, Grid, Tooltip, useMediaQuery } from '@mui/material';
import workFlowStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss' 
import styles from "./../../../../assets/styles/componentStyles/chatbot.module.scss";
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import whatsappIcon from './../../../../assets/Whatsapp.svg';
import facebookIcon from './../../../../assets/facebook-logo.svg';
import instagramIcon from './../../../../assets/images/channels/instagram/instagram.png';
import TemplateBlock from './templateNode';
import TextVariantNode from './textVariantNode';
import SaveVariable from './saveVariable';
import IconsColor from '../../../utility/iconsColor';
import { assignAndRemoveTagActionData, ChatbotStepActionData, ChatbotStepActionDataInterface, CustomAPICallActionData, customVariableConditions, removeContactActionData, ResetVariableActionData, retrieveContactActionData, saveContactActionData, SaveVariableActionData, saveVariableToVariableActionData, sendMediaActionData, sendWADMCarouselTemplateActionData, SendWADMTemplateActionData, SendWADMTextActionData,talkToAgentActionData } from '../../../../models/flowBuilderTypes';
import globalStyles from '../../../../assets/styles/global.module.scss';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import CustomAPICallNode from './customAPICallNode';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import CustomVarConditionNode from './customVarConditionNode';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { getValueOrDefault, isAdmin } from '../../../../utils/constants';
import CopyToClipboard from 'react-copy-to-clipboard';
import WorkflowCarouselTemplatePreview from '../../../manyChat/workFlowFormComponents/templateDetails/workflowCarouselTemplatePreview';
import { ACTION_TYPE_NAME, chatbot_step_type_id_basic, chatbot_step_type_id_webhook, getCurrentActiveNodeData, hasArchiveChatAction, hasTalkToAgentAction } from '../flowBuilderConstants';
import WebhookNode from './webhookNode';
import { chatbotExceptionNew, chatbotStepData } from '../../../../models/axiosModel';
import GlobalPopUp from '../../../utility/globalPopUp';
import NodeIsUseInExceptionWarning from './nodeIsUseInExceptionWarning';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore';
import ResetVariableNode from './resetVariableNode';
import VariableToVariableNode from './variableToVariableNode';
import SaveAndRemoveContactNode from './saveAndRemoveContactNode';
import SendMediaNode from './sendMediaNode';
import TalkToAgentNode from './talkToAgentNode';
import { blackColor } from '../../../../utils/colors';
import AssignAndRemoveTagNode from './assignAndRemoveTagNode';
import ArchiveChatNode from './archiveChatNode';
import clsx from 'clsx';
import { useIsCurrentActiveNode } from '../../../../hooks/useIsCurrentActiveNode';
import RetrieveContactNode from './retrieveContactNode';
import { INSTAGRAM_ACTION_TYPES } from '../../../../pages/ruleBasedInbox/constants';

const NodeWrapper = ({ id, data }: { id: string, data: ChatbotStepActionDataInterface[] }) => {
    
    const connection = useConnection();
    const connections = useNodeConnections();
    const { userDetail } = useContext(UserContext) as UserContextPayload
    const { selectedMessageTitle, deleteNode, setCurrentActiveNodeConfig, nodes, filteredNodes, searchQuery, currentIndex } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const isCurrentActiveNode = useIsCurrentActiveNode(id);
    const { currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    
    function getNodeActionComponent(actionType: string, id: string, data: ChatbotStepActionData<SendWADMTemplateActionData | SendWADMTextActionData | SaveVariableActionData | CustomAPICallActionData | customVariableConditions | ChatbotStepActionData<SaveVariableActionData[]> | ResetVariableActionData | saveVariableToVariableActionData | sendMediaActionData | saveContactActionData | removeContactActionData | talkToAgentActionData | assignAndRemoveTagActionData | retrieveContactActionData>) {
        switch (actionType) {
            case ACTION_TYPE_NAME["TEMPLATE"]:
            case ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]:
                return <TemplateBlock id={id} data={data as ChatbotStepActionData<SendWADMTemplateActionData>} />
            case ACTION_TYPE_NAME["TEXT"]:
            case INSTAGRAM_ACTION_TYPES["SEND_IG_DM_TEXT"]:
                return <TextVariantNode id={id} data={data as ChatbotStepActionData<SendWADMTextActionData>} />
            case ACTION_TYPE_NAME["SAVE_DATA"]:
                return <SaveVariable id={id} data={data as ChatbotStepActionData<SaveVariableActionData | ChatbotStepActionData<SaveVariableActionData>[]>} /> 
            case ACTION_TYPE_NAME["VARIABLE_ASSIGNMENT"]:
                return <VariableToVariableNode id={id} data={data as ChatbotStepActionData<saveVariableToVariableActionData>}  />
            case ACTION_TYPE_NAME["RESET_DATA"]: 
                return <ResetVariableNode id={id} data={data as ChatbotStepActionData<ResetVariableActionData>} />
            case ACTION_TYPE_NAME["CUSTOM_API"]:
                return <CustomAPICallNode id={id} data={data as ChatbotStepActionData<CustomAPICallActionData>} />
            case ACTION_TYPE_NAME["CONDITION"]: // This is just for FE & not BE. 
                return <CustomVarConditionNode id={id} data={data as ChatbotStepActionData<customVariableConditions>} />
            case ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]:
                return <WorkflowCarouselTemplatePreview actionData={data?.action_data} flagNodePreview /> 
            case ACTION_TYPE_NAME["AWAIT_WEBHOOK"]: 
                return <WebhookNode id={id} data={data as ChatbotStepActionData<CustomAPICallActionData>} />
            case ACTION_TYPE_NAME["SEND_MEDIA"]:
                return <SendMediaNode id={id} data={data as ChatbotStepActionData<sendMediaActionData>} />
            case ACTION_TYPE_NAME["SAVE_CONTACT"]:
            case ACTION_TYPE_NAME["REMOVE_CONTACT"]:
                return <SaveAndRemoveContactNode id={id} data={data as ChatbotStepActionData<saveContactActionData | removeContactActionData>} />
            case ACTION_TYPE_NAME["TALK_TO_AGENT"]:
                return <TalkToAgentNode id={id} data={data as ChatbotStepActionData<talkToAgentActionData>} />
            case ACTION_TYPE_NAME["ASSIGN_TAG"]:
            case ACTION_TYPE_NAME["REMOVE_TAG"]:
                return <AssignAndRemoveTagNode id={id} data={data as ChatbotStepActionData<assignAndRemoveTagActionData>} />
            case ACTION_TYPE_NAME["ARCHIVE_CHAT"]:
                return <ArchiveChatNode />
            case ACTION_TYPE_NAME["RETRIEVE_CONTACT"]:
                return <RetrieveContactNode id={id} data={data as ChatbotStepActionData<retrieveContactActionData>} />
            default:
                return <>
                </>
        }
    }

    const handleClickNewMessage = () => {
        setCurrentActiveNodeConfig((prevstate: any) => ({ ...prevstate, flagOpenConfigForm: true, nodeId: id, data: data, flag_initial: true }))
    }

    const [hoveredNode, setHoveredNode] = useState<string>("");
    const [flagHoveredNode, setFlagHoveredNode] = useState<boolean>(false);
    const [flagDeleteNodePopup, setFlagDeleteNodePopup] = useState<boolean>(false);
    const [selectedNode, setSelectedNode] = useState<string>("");
    const [copyText, setCopyText] = useState<string>("Copy"); 

    const [listOfExceptionNode, setListOfExceptionNode] = useState<any[]>([]);
    const [chatbotLevelException, setChatbotLevelException] = useState<chatbotExceptionNew | null>(null);
    const [flagNodeUseInException, setFlagNodeUseInException] = useState<boolean>(false);
    const flagInteractiveCanvas = useFlowBuilderStore((state) => state.flagInteractiveCanvas);
    

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }
    const handleMouseEnter = () => {
        if (hoveredNode != id) {
            setHoveredNode(id);
        }
    }

    const handleMouseLeave = () => {
        setTimeout(() => {
            setHoveredNode("");
        }, 200);
    }
    function connectionValid(nodeId: string) {
        return !(
            connection?.inProgress &&
            connection?.toHandle?.nodeId === nodeId &&
            connection?.isValid === false
        );
    }

    const checkIfThisNodeIsUseInException = () => {
        let flagIsNodeUseInException = false;
        let list_of_exception_node: any[] = [];
        let chatbot_level_exception: chatbotExceptionNew | null = null;

        // Step Level Exception 
        nodes?.forEach((node: any) => {
            if(node?.chatbot_step_exception?.target_chatbot_step?.target_chatbot_step_id == id){
                flagIsNodeUseInException = true; 
                list_of_exception_node.push(node);
            }
        })

        // Chatbot Level Exception
        if(currentActiveStaticWorkflow?.chatbot_exception?.flag_saved_in_BE){
            if(currentActiveStaticWorkflow?.chatbot_exception?.chatbot_step?.chatbot_step_id == id){
                flagIsNodeUseInException = true;
                chatbot_level_exception = currentActiveStaticWorkflow?.chatbot_exception;
            }
        }

        if(flagIsNodeUseInException) {
            setFlagNodeUseInException(true); 
            setChatbotLevelException(chatbot_level_exception);
            setListOfExceptionNode(list_of_exception_node);
        } 
        return flagIsNodeUseInException;
    }

    const onClickOfNode = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation(); // Prevents click from reaching parent
        setCurrentActiveNodeConfig((prevstate: any) => ({
            ...prevstate,
            flagOpenConfigForm: true,
            nodeId: id,
            data: data,
            flag_initial: true
        }));
    }

    const getNodeIconAndLabelObj = (icon: React.ReactElement, text: string) => {
        return {
            icon: icon, 
            label: text
        }
    }

    const getNodeIconAndLabel = () => {
        const currentNode = getCurrentActiveNodeData(id, nodes);
        let nodeIcon = <></>;
        let nodeText = "";
        if(currentNode){
            const stepId = currentNode?.chatbot_step_type_id;

            switch(stepId){
                case chatbot_step_type_id_webhook:
                    nodeIcon = <IconsColor iconName="webhookIcon" height={"28"} width={"28"} />;
                    nodeText = "Webhook";
                    break;
                
                case chatbot_step_type_id_basic:
                    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;

                    switch(channelName){
                        case "WhatsApp":
                            nodeIcon = <img alt="" src={whatsappIcon} height={"28"} width={"28"} className={globalStyles.displayFlexStyle} />;
                            nodeText = "WhatsApp";
                            break;
                        case "Instagram":
                            nodeIcon = <img alt="" src={instagramIcon} height={"28"} width={"28"} className={globalStyles.displayFlexStyle} />;
                            nodeText = "Instagram";
                            break;
                        case "Facebook":
                            nodeIcon = <img alt="" src={facebookIcon} height={"28"} width={"28"} className={globalStyles.displayFlexStyle} />;
                            nodeText = "Facebook";
                            break;
                        default:
                            nodeIcon = <img alt="" src={whatsappIcon} height={"28"} width={"28"} className={globalStyles.displayFlexStyle} />;
                            nodeText = "WhatsApp";
                            break;
                    }
            }
        }

        return getNodeIconAndLabelObj(nodeIcon, nodeText);
    }

    const onClickOfDeleteNodeIcon = () => {
        setSelectedNode(id);
        if(!checkIfThisNodeIsUseInException()){
            setFlagDeleteNodePopup(true);
        }
    }

    const checkIfSourceHandleIsConnectable = () => {
        if(isCurrentViewVersionPublished(currentActiveStaticWorkflow)) {
            return false;
        } else {
            // If a Talk to Agent action exists without a condition, the source handle cannot be connected.
            const doesTalkToAgentActionExist = hasTalkToAgentAction(data) as ChatbotStepActionData<talkToAgentActionData> | null;
            if(doesTalkToAgentActionExist && !(doesTalkToAgentActionExist?.action_data?.condition_group)) {
                return false;
            }

            const doesArchiveChatActionExist = hasArchiveChatAction(data);
            if(doesArchiveChatActionExist){
                return false;
            }
        }

        return true;
    }

    const getHighlightNodeStepName = () => {
        const stepName = getValueOrDefault(getCurrentActiveNodeData(id, nodes)?.chatbot_step_name);
        if(!searchQuery) return stepName;

        const regex = new RegExp(`(${searchQuery})`, "gi");
        const parts = stepName?.split(regex);

        return parts?.map((part: any, index: number) => {
            const isMatch = part?.toLowerCase() === searchQuery?.toLowerCase();

            if(!isMatch) return part;
            const isActive = filteredNodes?.findIndex((node: any) => node?.id === id) === currentIndex;

            return <span
                key={index}
                style={{
                    backgroundColor: isActive ? "yellow" : "orange",
                    padding: "2px",
                }}
            >
                {part}
            </span>
        })
    }

    return (
        <>
            {!isCurrentViewVersionPublished(currentActiveStaticWorkflow) &&
                <NodeToolbar
                    isVisible={hoveredNode == id || flagHoveredNode}
                    onMouseEnter={() => setFlagHoveredNode(true)}
                    onMouseLeave={() => setFlagHoveredNode(false)}
                >
                    <Grid item>
                        <Grid container gap={1}>
                            {/* <Grid item className={workFlowStyles.iconsStyle} onClick={() => { copyNode(id) }}>
                            <IconsColor iconName="Copy" height="16" width="16" fillColor="#000" />
                        </Grid> */}
                            <Grid
                                item
                                className={workFlowStyles.iconsStyle}
                                onClick={() => onClickOfDeleteNodeIcon()}
                            >
                                <IconsColor iconName="DeleteIcon" height="16" width="16" fillColor={blackColor} />
                            </Grid>
                        </Grid>
                    </Grid>
                </NodeToolbar>}

            {flagDeleteNodePopup &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${getValueOrDefault(getCurrentActiveNodeData(id, nodes)?.chatbot_step_name) ?? "this node"}`}
                    open={flagDeleteNodePopup}
                    onClose={() => { setFlagDeleteNodePopup(false); }}
                    onDelete={() => {
                        deleteNode(selectedNode);
                        setFlagDeleteNodePopup(false);
                    }}
                />
            } 

            {flagNodeUseInException && 
                <GlobalPopUp
                    open={flagNodeUseInException}
                    onClose={() => { setFlagNodeUseInException(false);}}
                    handleClose={() => { setFlagNodeUseInException(false);}}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "800px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <NodeIsUseInExceptionWarning
                        setFlagNodeUseInException={setFlagNodeUseInException} 
                        listOfExceptionNode={listOfExceptionNode}  
                        chatbotLevelException={chatbotLevelException}
                        selectedNode={selectedNode}
                    />
                </GlobalPopUp>
            }

            <Grid item
                className={clsx(workFlowStyles.nodeWrapper, data?.[0]?.flagError && workFlowStyles.errorNodeWrapper, isCurrentActiveNode && workFlowStyles.currentActiveNode)}
                onClick={(e) => onClickOfNode(e)}
                onMouseEnter={() => { if(flagInteractiveCanvas) handleMouseEnter() }}
                onMouseLeave={() => { if(flagInteractiveCanvas) handleMouseLeave() }}
            >
                <Grid container direction="column" gap="21px">
                    <Grid item>
                        <Grid container className={globalStyles.displayFlex} gap="12px">
                            <Grid item className={globalStyles.displayFlexStyle}>
                                {getNodeIconAndLabel().icon}
                            </Grid>
                            <Grid item>
                                <Grid container direction={"column"} gap={"2px"}>
                                    <Grid item className={workFlowStyles.messageMediaNameStyle}>
                                        {getNodeIconAndLabel().label}
                                    </Grid>
                                    <Grid item className={workFlowStyles.triggerCardHeadingStyle}>
                                        {getHighlightNodeStepName()}
                                    </Grid>
                                    {isAdmin(userDetail) &&
                                        <Grid item>
                                            <Grid container gap={"10px"}>
                                                <Grid item className={workFlowStyles.triggerCardHeadingStyle}>
                                                    Step ID: {id}
                                                </Grid>
                                                <Grid item>
                                                    <CopyToClipboard text={id}>
                                                        <Tooltip
                                                            title={copyText}
                                                            onMouseLeave={() => setCopyText("Copy!")}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setCopyText("Copied!");
                                                            }}
                                                        >
                                                            <Grid item>
                                                                <IconsColor iconName={"Copy"} fillColor={blackColor} width={"16"} height={"16"} />
                                                            </Grid>
                                                        </Tooltip>
                                                    </CopyToClipboard>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                    {/* <Grid item className={workFlowStyles.triggerCardHeadingStyle}>
                                        {selectedMessageTitle || "..."}
                                    </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {data.filter((action: ChatbotStepActionDataInterface) => action?.action_type).map((action: ChatbotStepActionDataInterface) => {
                        return <>
                            {getNodeActionComponent(action.action_type.action_type_name, action.chatbot_step_id, action)}
                            <Divider />
                        </>
                    })

                    }
                    <Grid item>
                        <Grid container direction={"column"} gap={"12px"}>
                            <Grid item className={workFlowStyles.addTextBlockStyle} onClick={handleClickNewMessage} >
                                <Grid container alignItems={"center"} justifyContent={"center"} flexWrap={"nowrap"}>
                                    <Grid item>
                                        Add an Action
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container justifyContent={"end"} alignItems={"center"}>
                            <Grid item className={`${workFlowStyles.triggerCardSubHeadingStyle} ${globalStyles.primaryFontWeight}`} textAlign={"end"}>
                                Next Step
                            </Grid>
                            {
                                <Grid item>
                                    <Handle type="target"
                                        isConnectable={!isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        className={connection.inProgress ? workFlowStyles.nodeWrapperTargetHandleDuringConnection : workFlowStyles.nodeWrapperTargetHandle} position={Position.Left}
                                        id={id}
                                    />
                                </Grid>}
                            <Grid item className={workFlowStyles.nodeWrapperSourceHandle}>
                                <Handle
                                    isConnectable={checkIfSourceHandleIsConnectable()}
                                    type="source" position={Position.Right}
                                    id={id}
                                />
                            </Grid>
                        </Grid>
                    </Grid>


                </Grid>
            </Grid>
        </>
    );
};

export default memo(NodeWrapper);